import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity, DollarSign, MessageSquare, Zap, Mic, Brain, Volume2 } from "lucide-react";

type Stats = {
  total_turns?: number;
  total_cost_usd?: number;
  total_llm_tokens?: number;
  total_stt_ms?: number;
};

interface LatencyBreakdown {
  stt_ms?: number;
  llm_ms?: number;
  tts_ms?: number;
  total_ms?: number;
}

export function MetricsPanel({ stats, lastTurn }: { stats: Stats; lastTurn?: LatencyBreakdown | null }) {
  const items = [
    { icon: MessageSquare, label: "Turnos", value: String(stats.total_turns ?? 0) },
    { icon: Zap, label: "Tokens LLM", value: (stats.total_llm_tokens ?? 0).toLocaleString("pt-BR") },
    { icon: Activity, label: "STT (s)", value: ((stats.total_stt_ms ?? 0) / 1000).toFixed(1) },
    { icon: DollarSign, label: "Custo USD", value: `$${Number(stats.total_cost_usd ?? 0).toFixed(4)}` },
  ];
  const breakdown = lastTurn && (lastTurn.stt_ms || lastTurn.llm_ms || lastTurn.tts_ms);
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm">Métricas</CardTitle>
      </CardHeader>
      <CardContent className="pt-0 space-y-3">
        <div className="grid grid-cols-2 gap-3">
          {items.map((it) => (
            <div key={it.label} className="rounded-md border border-border/50 p-3 bg-muted/30">
              <div className="flex items-center gap-1.5 text-[10px] text-muted-foreground uppercase tracking-wider">
                <it.icon className="w-3 h-3" /> {it.label}
              </div>
              <div className="mt-1 text-base font-semibold tabular-nums">{it.value}</div>
            </div>
          ))}
        </div>
        {breakdown && (
          <div>
            <div className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1.5">
              Última latência (ms)
            </div>
            <div className="grid grid-cols-3 gap-2">
              <LatencyTile icon={Mic} label="STT" value={lastTurn?.stt_ms} />
              <LatencyTile icon={Brain} label="LLM" value={lastTurn?.llm_ms} />
              <LatencyTile icon={Volume2} label="TTS" value={lastTurn?.tts_ms} />
            </div>
            {lastTurn?.total_ms ? (
              <div className="mt-1.5 text-[10px] text-muted-foreground text-right tabular-nums">
                Total: {lastTurn.total_ms} ms
              </div>
            ) : null}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

function LatencyTile({ icon: Icon, label, value }: { icon: any; label: string; value?: number }) {
  return (
    <div className="rounded-md border border-border/50 p-2 bg-muted/20 flex items-center gap-2">
      <Icon className="w-3.5 h-3.5 text-muted-foreground" />
      <div className="min-w-0">
        <div className="text-[9px] text-muted-foreground uppercase tracking-wider">{label}</div>
        <div className="text-xs font-semibold tabular-nums">{value ? `${value}` : "—"}</div>
      </div>
    </div>
  );
}
